// GENERATED by scripts/build-icon-sprite.mjs from src/assets/icons/*.svg.
// Do not hand-edit; add or remove a .svg file and re-run the build.

export const SPRITE_VERSION = 'd320517bbf';
